// Dee's ruling (2026-10-30): the till names an order as TKF- plus the six-character short
// code, everywhere. An order with no short code (old rows from before the backfill) falls
// back to the last six characters of its id, uppercased - never the raw id. The server
// mints the short code the same way (last six of the id, uppercased), so both paths agree.
export function orderCode(o: { id: string; shortCode: string | null | undefined }): string {
  const short = typeof o.shortCode === 'string' && o.shortCode.trim() !== '' ? o.shortCode.trim() : o.id.slice(-6)
  return `TKF-${short.toUpperCase()}`
}
